import { SoftDeleteInfo } from "@/types/deleteRequest";
import {Kato, KindergartenPaidAmount, LmsSystemItem} from "@/types/kindergarten";

export interface Report {
  uuid: string;
  reportStatus: string;
  fileName: string;
  fileSize: string;
  bin: string,
  lmsId: string,
  accountingMonth: number,
  accountingYear: number,
  katoCode: number,
  reportStatusText: string,
  deletion?: SoftDeleteInfo | null,
}

export interface CalculationReportResponse {
  accountingMonth: number,
  accountingYear: number
  binListStr: string | null
  lmsIdListStr: string | null
}

export interface KindergartenCalculationReport {
  id: number;
  bin: string;
  lmsId: string;
  accountingMonth: number;
  accountingYear: number;
  totalSum: string;
  report: Report | null;
  signStatus: string;
  rejectComment: string
  childCount: number;
  lmsSystem: LmsSystemItem | null;
  kindergartenPaidAmounts: KindergartenPaidAmount[] | null;
  totalPaidAmount: number | null;
  totalReminderAmount: number | null;
  calculationReportInfo: CalculationReportInfo | null;
}

export interface Kindergarten1cActReconciliation {
  id: number;
  createdBy: string;
  report: Report;
  kindergartenHeadSignStatus: string;
  kindergartenHeadSignDateTime: string;
  hasAccountantChecked: boolean;
  finDirSignStatus: string;
  finDirSignDateTime: string;
}

export interface CalculationReportInfo {
  currentDate: Date | null;
  kindergartenName: string | null;
  bin: string | null;
  lmsId: string | null;
  year: number | null;
  month: number | null;
  monthKz: string | null;
  monthRu: string | null;
  totalSum: string | null;
  totalSumInDecimal: number | null;
  totalSumInDecimalLms: number | null;
  calculationTableData: CalculationReportChildInfo[]
}

export interface CalculationReportChildInfo {
  number: number | null;
  childIin: string | null;
  childFio: string | null;
  durationTime: string | null;
  totalDaysInMonth: number | null;
  workingDays: number | null;
  weekendDays: number | null;
  excusedAbsenceDays: number | null;
  unexcusedAbsenceDays: number | null;
  presenceDays: number | null;
  sickDays: number | null;
  vacationDays: number | null;
  recalculationAmount: string | null;
  sum: string | null;
}

export interface KdgLmsSystemNotificationDto {
  id: number;
  bin: string;
  lmsId: string;
  lmsName: string;
  address: string;
  kindergartenName: string;
  katoCode: number | undefined;
  fundingStatus: string | undefined;
  notificationStatus: string | undefined;
  lastMessageStatus: string | undefined;
  kdgNotificationId: string | undefined;
  directorPhone: string | undefined;
}

export interface KdgLmsSystemNotificationMessageDto {
  id: string;
  message: string;
  status: string;
  createdAt: any;
  createdByFullName: any;
  readAt: any | null;
  readByDto: any | null;
  sendByManager: boolean | false
  fileDtos: any[] | undefined
  totalRowCounts: number | undefined
}

export interface KdgLmsSystemNotificationRequestDto {
  status: boolean;
  lmsSystemId: number | null | undefined;
  kdgNotificationId: string | null | undefined;
}

export interface KdgLmsSystemNotificationMessageRequestDto {
  message: string;
  lmsSystemId: number | null | undefined;
  kdgNotificationId: string | null | undefined;
}

export class ReportSearchParam {
  pageSize: number = 10;
  page: number = 0;
  accountingMonth: number | null = null;
  accountingYear: number | null = null;
  reportDateFrom: Date | null = null;
  reportDateTo: Date | null = null;
  bin: string | null = null;
  lmsId: string | null = null;
  katoCode: Kato | null = null;
  reportType: string | null = null;
}

export class KindergartenCalculationSearchParam {
  pageSize: number = 10;
  page: number = 0;
  accountingMonth: number | null = null;
  accountingYear: number | null = null;
  bin: string | null = null;
  signStatus: string | null = null;
  katoCode: number | null = null;
  includeDeleted: boolean = false;
}

export class Generate1CReportAsyncRequest {
  accountingMonth: number;
  accountingYear: number;
  approveDate: Date | null = null;
  katoCode: number | null = null;
  constructor(accountingMonth: number, accountingYear: number, approveDate: Date | null = null, katoCode: number | null = null) {
    this.accountingMonth = accountingMonth;
    this.accountingYear = accountingYear;
    this.approveDate = approveDate;
    this.katoCode = katoCode;
  }
}

export class GenerateReportForMIOAsyncRequest {
  startAccountingMonth: number;
  endAccountingMonth: number;
  accountingYear: number;
  katoCode: number | null = null;
  constructor(startAccountingMonth: number, endAccountingMonth: number, accountingYear: number, katoCode: number | null = null) {
    this.startAccountingMonth = startAccountingMonth;
    this.endAccountingMonth = endAccountingMonth;
    this.accountingYear = accountingYear;
    this.katoCode = katoCode;
  }
}

export class GenerateReportForMonitoringAsyncRequest {
  accountingMonth: number;
  accountingYear: number;
  katoCode: number| null = null;
  binList: string;
  lmsIdList: string;
  constructor(accountingMonth: number, accountingYear: number, katoCode: number| null = null, binList: string = "", lmsIdList: string = "") {
    this.accountingMonth = accountingMonth;
    this.accountingYear = accountingYear;
    this.katoCode = katoCode;
    this.binList = binList;
    this.lmsIdList = lmsIdList;
  }
}

export class RejectCalculationReportRequest {
  kindergartenCalculationId: number;
  rejectComment: string;
  constructor(kindergartenCalculationId: number, rejectComment: string) {
    this.kindergartenCalculationId = kindergartenCalculationId;
    this.rejectComment = rejectComment;
  }
}

export class KdgNotificationSearchParam {
  pageSize: number = 10;
  page: number = 0;
  bin: string | null = null;
  name: string | null = null;
  katoCode: number | null = null;
  executor: string | null = null;
  fundingStatus: string | null = null;
  notificationStatus: string | null = null;
  lastMessageStatus: string | null = null;
}
